import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { ACESFilmicToneMapping, AgXToneMapping, NeutralToneMapping } from 'three';
import { $needsRender, $progressTracker, $renderer, $scene, $shouldAttemptPreload } from '../model-viewer-base.js';
import { clamp, deserializeUrl } from '../utilities.js';
export var BASE_OPACITY = 0.5;
var DEFAULT_SHADOW_INTENSITY = 0.0;
var DEFAULT_SHADOW_SOFTNESS = 1.0;
var DEFAULT_EXPOSURE = 1.0;
export var $currentEnvironmentMap = Symbol('currentEnvironmentMap');
export var $currentBackground = Symbol('currentBackground');
export var $updateEnvironment = Symbol('updateEnvironment');
var $cancelEnvironmentUpdate = Symbol('cancelEnvironmentUpdate');
export var EnvironmentMixin = function EnvironmentMixin(ModelViewerElement) {
  var _a, _b, _c;
  var EnvironmentModelViewerElement = /*#__PURE__*/function (_ModelViewerElement, _ref) {
    _inherits(EnvironmentModelViewerElement, _ModelViewerElement);
    var _super = _createSuper(EnvironmentModelViewerElement);
    function EnvironmentModelViewerElement() {
      var _this;
      _classCallCheck(this, EnvironmentModelViewerElement);
      _this = _super.apply(this, arguments);
      _this.environmentImage = null;
      _this.skyboxImage = null;
      _this.shadowIntensity = DEFAULT_SHADOW_INTENSITY;
      _this.shadowSoftness = DEFAULT_SHADOW_SOFTNESS;
      _this.exposure = DEFAULT_EXPOSURE;
      _this.toneMapping = 'auto';
      _this.skyboxHeight = '0';
      _this[_a] = null;
      _this[_b] = null;
      _this[_c] = null;
      return _this;
    }
    _createClass(EnvironmentModelViewerElement, [{
      key: "updated",
      value: function updated(changedProperties) {
        _get(_getPrototypeOf(EnvironmentModelViewerElement.prototype), "updated", this).call(this, changedProperties);
        if (changedProperties.has('shadowIntensity')) {
          this[$scene].setShadowIntensity(this.shadowIntensity * BASE_OPACITY);
          this[$needsRender]();
        }
        if (changedProperties.has('shadowSoftness')) {
          this[$scene].setShadowSoftness(this.shadowSoftness);
          this[$needsRender]();
        }
        if (changedProperties.has('exposure')) {
          this[$scene].exposure = this.exposure;
          this[$needsRender]();
        }
        if (changedProperties.has('toneMapping')) {
          this[$scene].toneMapping = this.toneMapping === 'commerce' || this.toneMapping === 'neutral' ? NeutralToneMapping : this.toneMapping === 'agx' ? AgXToneMapping : ACESFilmicToneMapping;
          this[$needsRender]();
        }
        if ((changedProperties.has('environmentImage') || changedProperties.has('skyboxImage')) && this[$shouldAttemptPreload]()) {
          this[$updateEnvironment]();
        }
        if (changedProperties.has('skyboxHeight')) {
          this[$scene].setGroundedSkybox();
          this[$needsRender]();
        }
      }
    }, {
      key: "hasBakedShadow",
      value: function hasBakedShadow() {
        return this[$scene].bakedShadows.size > 0;
      }
    }, {
      key: _ref,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var skyboxImage, environmentImage, textureUtils, updateEnvProgress, _yield$textureUtils$g, environmentMap, skybox;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                skyboxImage = this.skyboxImage, environmentImage = this.environmentImage;
                if (this[$cancelEnvironmentUpdate] != null) {
                  this[$cancelEnvironmentUpdate]();
                  this[$cancelEnvironmentUpdate] = null;
                }
                textureUtils = this[$renderer].textureUtils;
                if (!(textureUtils == null)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                updateEnvProgress = this[$progressTracker].beginActivity('environment-update');
                _context.prev = 6;
                _context.next = 9;
                return textureUtils.generateEnvironmentMapAndSkybox(deserializeUrl(skyboxImage), environmentImage, function (progress) {
                  return updateEnvProgress(clamp(progress, 0, 1));
                });
              case 9:
                _yield$textureUtils$g = _context.sent;
                environmentMap = _yield$textureUtils$g.environmentMap;
                skybox = _yield$textureUtils$g.skybox;
                if (this[$currentEnvironmentMap] !== environmentMap) {
                  this[$currentEnvironmentMap] = environmentMap;
                  this.dispatchEvent(new CustomEvent('environment-change'));
                }
                if (skybox != null) {
                  // When using the same environment and skybox, use the environment as
                  // it gives HDR filtering.
                  this[$currentBackground] = skybox.name === environmentMap.name ? environmentMap : skybox;
                } else {
                  this[$currentBackground] = null;
                }
                this[$scene].setEnvironmentAndSkybox(this[$currentEnvironmentMap], this[$currentBackground]);
                _context.next = 22;
                break;
              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);
                if (!(_context.t0 instanceof Error)) {
                  _context.next = 22;
                  break;
                }
                this[$scene].setEnvironmentAndSkybox(null, null);
                throw _context.t0;
              case 22:
                _context.prev = 22;
                updateEnvProgress(1.0);
                return _context.finish(22);
              case 25:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[6, 17, 22, 25]]);
        }));
        function value() {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    }]);
    return EnvironmentModelViewerElement;
  }(ModelViewerElement, (_a = $currentEnvironmentMap, _b = $currentBackground, _c = $cancelEnvironmentUpdate, $updateEnvironment));
  __decorate([property({
    type: String,
    attribute: 'environment-image'
  })], EnvironmentModelViewerElement.prototype, "environmentImage", void 0);
  __decorate([property({
    type: String,
    attribute: 'skybox-image'
  })], EnvironmentModelViewerElement.prototype, "skyboxImage", void 0);
  __decorate([property({
    type: Number,
    attribute: 'shadow-intensity'
  })], EnvironmentModelViewerElement.prototype, "shadowIntensity", void 0);
  __decorate([property({
    type: Number,
    attribute: 'shadow-softness'
  })], EnvironmentModelViewerElement.prototype, "shadowSoftness", void 0);
  __decorate([property({
    type: Number
  })], EnvironmentModelViewerElement.prototype, "exposure", void 0);
  __decorate([property({
    type: String,
    attribute: 'tone-mapping'
  })], EnvironmentModelViewerElement.prototype, "toneMapping", void 0);
  __decorate([property({
    type: String,
    attribute: 'skybox-height'
  })], EnvironmentModelViewerElement.prototype, "skyboxHeight", void 0);
  return EnvironmentModelViewerElement;
};